import actions from "./actions";
import mutations from "./mutations";

export default {
    namespaced: true,
    state: {
        key: "",
        page: 0,
    },
    mutations,
    actions,
};
